export default __webpack_public_path__ + "static/media/revisar.4e5a54e4.svg";